import { CSVLink } from 'react-csv';
import { useNavigate } from "react-router-dom";
import { useState, useEffect, useContext } from "react";
import { Stack, StackItem, TooltipHost } from "@fluentui/react";
import { FullScreen, useFullScreenHandle } from "react-full-screen"
import { Button, MenuList, MenuButton, Divider, Text, Body1Strong, Caption1, FluentProvider, Input, Tooltip } from "@fluentui/react-components";
import { Filter20Filled, FilterDismiss20Filled, ArrowClockwise20Regular, ArrowDownload20Regular, Dismiss16Regular, Info16Filled } from "@fluentui/react-icons";
import { exportIcons, filterIcons, refreshIcons, resetFilterIcons } from "../../../components/side_menu/overflowIcons";
import { OverflowSetCustomExample } from "../../../components/side_menu/overFlowSet.component";
import { FileDownloadComponent } from "../../../components/fileExport/file.export.component";
import { DatepickerComponent } from "../../../components/picker/datepicker.component";
import { Breadcrumbs } from "../../../components/breadcrumbs/breadcrumbs.component";
import { SideMenu } from "../../../components/side_menu/inline_side_menu.component";
import { DropdownComponent } from "../../../components/dropdown/dropdown.component";
import { SkeletonDataTable } from "../../../components/skeleton/skeletonDataTable";
import { Pagination } from "../../../components/pagination/pagination.component";
import { DataTable } from "../../../components/data_table/data_table.component";
import { SearchBar } from "../../../components/searchbar/searchbar.component";
import { MenuDropdown } from "../../../components/dropdown/menu.component";
import { ToastComponent } from "../../../components/toast/toast.component";
import { InfoBar } from "../../../components/infoBar/infoBar.component";
import { AuditPages } from "../../../components/side_menu/InlineSidenav";
import FullScreenButton from "../../../components/fullscreen/fullScreen.component";
import OverLay from "../../../components/side_menu/overlay_side_menu.component";
import { GlobalContext } from "../../../hooks/globalContext";
import { usePermissionStore } from "../../../Store/permissionStore";
import { Activity_log_func } from "../../../api/activity_log/activity_log_func";
import { convertToExcelFormat, convertToLocalTimezone, convertUTCToReadableFormat } from "../../../utility/utils";
import { buttonContent, DynamicBoxingCSS, SubSectionResponsive, parentHome, primaryIcon, secondaryIcon, wraperStyle, dashboardTheme, BreadcrumbsBorder, timezoneInfo } from "../../../styles/customStyles";

export const Remediation_Activity_log = () => {
  const [final_data, set_final_data]: any = useState(null);
  const [tableData, setTableData] = useState([]);
  const [exportData, setExportData] = useState([]);
  const [exportDetails, setExportDetails]: any = useState([]);
  const [leftOpenSubMenu, setleftOpenSubMenu] = useState(true);
  const [isResetDisabled, setResetDisabled] = useState(true);
  const [loading, setLoading] = useState(true);
  const [isfilter, setIsFilter] = useState(false);
  const [isRefresh, setRefresh]: any = useState(false);
  const [overlayOpen, setOverlayOpen] = useState(false);
  const [filterMenuOpen, setFilterMenuOpen] = useState(false);
  const [refreshToast, setRefreshToast]: any = useState(false);
  const [exportBtnClicked, setExportBtnClicked] = useState(false);
  const [overlayData, setOverlayData] = useState<any>(false);
  const [currentPageNo, setCurrentPageNo] = useState(1);
  const [activity, setActivity]: any = useState('{}');
  const [searchVal, setSearchVal] = useState("");
  const [activityExportData, setActivityExportData] = useState<any>('No data available');
  const [dropDownValue1, setDropDownValue1] = useState<any>();
  const [dropDownValue2, setDropDownValue2] = useState<any>();
  const [filterArray, setFilterArray] = useState<string[]>([]);
  const [uniqueCreatedBy, setUniqueCreatedBy] = useState<string[]>([]);
  const [uniqueModule, setUniqueModule] = useState<string[]>([]);
  const [uniqueAction, setUniqueAction] = useState<string[]>([]);
  const [uniqueStatus, setUniqueStatus] = useState<string[]>([]);
  const [createdByOptions, setCreatedByOptions] = useState<any[]>([]);
  const [moduleOptions, setModuleOptions] = useState<any[]>([]);
  const [actionOptions, setActionOptions] = useState<any[]>([]);
  const [statusOptions, setStatusOptions] = useState<any[]>([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [errorMessage, setErrorMessage] = useState<String>('');
  const [isToast, setIsToast] = useState(false);

  const navigate = useNavigate();
  const contextValue: any = useContext(GlobalContext);
  const { tenantName } = contextValue;
  var userTimeZone = contextValue.userSessionDetails?.otherDetails?.TimeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
  const formattedTimeZone = userTimeZone.replace('_', ' ').replace('/', ' / ');

  const { permissions } = usePermissionStore();
  const permitPrimary = (permissions.includes("all") || permissions.includes("activityLog_ReadandExport"));
  const permitSecondary = (permitPrimary || permissions.includes("activityLog_Fullaccess"));

  const body = (content: any) => (<Body1Strong> {content} </Body1Strong>);
  const cap = (content: any) => (<Caption1> {content} </Caption1>);
  const exists = (<span style={{ color: 'red' }}> This column is already filtered </span>);
  const empty = (<StackItem><Text /></StackItem>);

  const Theme = ({ children }) => (
    <FluentProvider theme={dashboardTheme}>
      <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}> {children} </Stack>
    </FluentProvider>
  );

  const nope = (<Theme> <StackItem> Not applicalble </StackItem> </Theme>);

  const none = (
    <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}>
      <StackItem> <Text size={500}> No result. </Text> </StackItem>
    </Stack>
  );

  const handle = useFullScreenHandle();

  useEffect(() => {
    const generateOptions = (data) => data?.map((item) => ({ key: item, label: cap(item) })) || [];
    setCreatedByOptions(generateOptions(uniqueCreatedBy));
    setModuleOptions(generateOptions(uniqueModule));
    setActionOptions(generateOptions(uniqueAction));
    setStatusOptions(generateOptions(uniqueStatus));
  }, [uniqueCreatedBy, uniqueModule, uniqueAction, uniqueStatus]);

  const handleFilterArray = (): any => {
    const result = dropDownValue1 + " : " + dropDownValue2;
    setFilterArray([...filterArray, result])
    setIsFilter(true);
    setLoading(true);
    setDropDownValue1('');
    setDropDownValue2('');
    if (filterArray.some((filter) => filter.startsWith(`${dropDownValue1} :`))) {
      setErrorMessage(`${dropDownValue1} is already filtered.`);
      return;
    } else {
      setErrorMessage('');
    };
  };

  const handleCloseFilter = (index: any): any => {
    setFilterArray(filterArray.filter((x, itemIndex) => itemIndex !== index));
    setDropDownValue1('');
    setDropDownValue2('');
  };

  useEffect(() => {
    if (filterArray.length > 0) {
      setResetDisabled(false);
    } else {
      setResetDisabled(true);
    };
  }, [filterArray]);

  const inputChange = (e: any) => {
    const { value, name } = e.target;
    const patterns = { alpha: /^[A-Za-z ]*$/, alphaNumeric: /^[A-Za-z0-9 ]*$/, numeric: /^[0-9]*$/ };
    return filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`))
      ? setErrorMessage(`${dropDownValue1} is already filtered.`)
      : (setErrorMessage(''), name === 'filter' && dropDownValue1 === 'Activity' && patterns.alphaNumeric.test(value) && setDropDownValue2(value));
  };

  useEffect(() => {
    var tempExportData: any = [];
    exportDetails?.length > 0 && exportDetails.map((val: any) => {
      const { pageName, time, initiatedBy, action, status } = val;
      const { activity } = val || {};
      if (pageName !== 'Devices') {
        tempExportData.push({
          Date: time ? convertToExcelFormat(time) : "-",
          Module: pageName,
          Activity: JSON.parse(activity)?.summary,
          'Initiated By': initiatedBy,
          Action: action,
          Status: status
        });
      }
    });
    setExportData(tempExportData);
  }, [exportDetails]);

  useEffect(() => {
    exportData.length > 0 && document.getElementById('csv-export-link')?.click();
  }, [exportData]);

  useEffect(() => {
    if (final_data !== undefined && final_data !== null) {
      const extractUniqueValues = (data: any[], key: string) => Array.from(
        new Set(data.map(item => item[key]?.trim()).filter(val => val && val !== '-'))
      );
      const uniqueKeys = ['initiatedBy', 'pageName', 'action', 'status'];
      const [uniqueCreatedBy, uniqueModule, uniqueAction, uniqueStatus] = uniqueKeys.map(key => extractUniqueValues(final_data, key));
      setUniqueCreatedBy(uniqueCreatedBy);
      setUniqueModule(uniqueModule);
      setUniqueAction(uniqueAction);
      setUniqueStatus(uniqueStatus);
    } else {
      setUniqueCreatedBy([]);
      setUniqueModule([]);
      setUniqueAction([]);
    };
  }, [final_data]);

  useEffect(() => {
    var tempTableData: any = [];

    final_data !== undefined && final_data !== null
      ? final_data.filter(val => val.pageName == "Remediation assignment").map((val: any, i: any) => {
        var activityVal = JSON.parse(val?.activity)?.summary;
        const { pageName, ID, activity, time, initiatedBy, action, status } = val;

        const button: any = { appearance: "transparent", size: "small", style: buttonContent };
        const handleTime = () => { setOverlayOpen(true); setOverlayData(val); setActivity(JSON.parse(activity)) };

        const accessYes = () => (
          <Button {...button} id="ButtonHover" onClick={handleTime}> {time ? convertUTCToReadableFormat(time) : ''} </Button>
        );

        const accessNo = () => (
          <TooltipHost content="You do not have access">
            <Button {...button}> {time ? new Date(time * 1000).toLocaleString() : ''} </Button>
          </TooltipHost>
        );

        if (pageName !== 'Devices') {
          tempTableData.push({
            id: ID,
            checkbox: "hide",
            date: { id: i, label: permitPrimary ? accessYes() : accessNo() },
            ...(permitPrimary && { date_timezoned: { id: i, label: cap(time ? convertToLocalTimezone(time, userTimeZone) : '') } }),
            page: { label: cap(pageName), status: "" },
            activity: { label: cap(activityVal) },
            initiated_by: { label: cap(initiatedBy) },
            action: { label: cap(action) },
            status: { label: cap(status) }
          });
        }
      }) : (tempTableData = []);

    tempTableData.length > 0 ? setTableData(tempTableData) : setTableData([]);

    setTimeout(() => {
      final_data !== undefined && final_data !== null && setLoading(false);
      if (isRefresh) {
        setRefresh(false);
        setRefreshToast(true);
        setTimeout(() => { setRefreshToast(false) }, 3000);
      };
    }, 500);
  }, [final_data, permissions]);

  const { action, activity: dataActivity, name: dataName, type: dataType, deviceCnt: dataCount, classificationNames: dataClass, remediationName: dataRemedy, attachedGroups: dataAttach, detachedGroups: dataDetach, surveyName: dataSurvey } = overlayData;
  const { time: checkTime, pageName: checkPageName, initiatedBy: checkInitiate, action: checkAction, status: checkStatus } = overlayData || {};
  const { summary: checkSummary } = activity || {};
  const { name, type, deviceCnt, classificationNames, remediationName, attachedGroups, detachedGroups, surveyName } = activity;

  const Pages = (condition: any) => (checkPageName === condition);
  const ActionA = (condition: any) => (checkAction === condition);
  const ActionB = (condition: any) => (action === condition);

  useEffect(() => {
    var data = '';

    data = `Activity
            \nDate and time of activity - ${checkTime ? new Date(checkTime * 1000).toLocaleString() : ''}
            \nModule where the activity was performed - ${checkPageName}
            \nActivity - ${checkSummary}
            \nInitiated by - ${checkInitiate}
            \nAction - ${checkAction}
            \nStatus - ${checkStatus}`;

    const first = (
      data += `\n----------------------------------------
               \nTarget
               \nNot applicalble`
    );
    const second = (
      data += `\n---------------------------------------- 
                \nModified properties
                \nNot applicalble`
    );
    const third = (
      data += `\n----------------------------------------
               \nModified Properties
               \nClassification name - ${classificationNames}`
    );
    const fourth = (
      data += `\n----------------------------------------
                \nTarget
                \nRemediation name - ${remediationName}
                \nAttached scope - ${attachedGroups}
                \nDetached scope - ${detachedGroups}`
    );
    const fifth = (
      data += `\n----------------------------------------
               \nTarget
               \nClassification name - ${name}
               \nOperation type - ${type}
               \nTotal number of devices added - ${deviceCnt}`
    );
    const sixth = (
      data += `\n----------------------------------------
               \nTarget
               \nSurvey name - ${surveyName}
               \nAttached devices list - ${attachedGroups}
               \nDetached devices list - ${detachedGroups}`
    );
    const seventh = (
      data += `\n----------------------------------------
               \nTarget
               \nCompliance Policies name - ${remediationName}
               \nAttached devices list - ${attachedGroups}
               \nDetached devices list - ${detachedGroups}`
    );
    const eigth = (
      data += `\n----------------------------------------
               \nTarget
               \nConditional Access name - ${remediationName}
               \nAttached devices list - ${attachedGroups}
               \nDetached devices list - ${detachedGroups}`
    );
    const ninth = (
      data += `\n----------------------------------------
               \nTarget
               \nData Collection name - ${remediationName}
               \nAttached devices list - ${attachedGroups}
               \nDetached devices list - ${detachedGroups}`
    );

    const actionsMap = {
      "Overview": {
        "Export": [first, second]
      },
      "Device Classification": {
        "Export": [first, second],
        "Add": [fifth, second],
        "Delete": [first, third],
        "Create": [first, third]
      },
      "Remediation list": {
        "Export": [first, second]
      },
      "Remediation assignment": {
        "Export": [first, second],
        "Add": [fourth, second]
      },
      "User Survey list": {
        "Export": [first, second]
      },
      "User Survey assignment": {
        "Export": [first, second],
        "Add": [sixth, second]
      },
      "Compliance Policies list": {
        "Export": [first, second]
      },
      "Compliance Policies assignment": {
        "Export": [first, second],
        "Add": [seventh, second]
      },
      "Conditional Access list": {
        "Export": [first, second]
      },
      "Conditional Access assignment": {
        "Export": [first, second],
        "Add": [eigth, second]
      },
      "Data Collection assignment": {
        "Export": [first, second],
        "Add": [ninth, second]
      },
      "Monitor list": {
        "Export": [first, second]
      },
      "Monitor assignment": {
        "Export": [first, second],
        "Add": [fourth, second]
      }
    };

    const page = Object.keys(actionsMap).find(Pages);

    if (page) {
      const actionKey = Object.keys(actionsMap[page]).find(ActionA) || Object.keys(actionsMap[page]).find(ActionB);
      if (actionKey) {
        actionsMap[page][actionKey]();
        setActivityExportData(data);
      };
    };
  }, [overlayData]);

  const breadcrumbData = () => (
    <StackItem grow shrink style={BreadcrumbsBorder}>
      <Stack tokens={{ childrenGap: 10 }} horizontal>
        <StackItem grow shrink>
          <Stack tokens={{ childrenGap: 5 }} horizontalAlign="start">
            {empty}
            <StackItem grow shrink>
              <Breadcrumbs items={[
                { name: "Manage", link: "/home" },
                { name: "Devices", link: "/manage/devices/overview" },
                {
                  name: localStorage.getItem('assignmentType') === 'datacollection'
                    ? 'Data Collection'
                    : localStorage.getItem('assignmentType') === 'conditionalaccess'
                      ? 'Conditional Access'
                      : localStorage.getItem('assignmentType') === 'policy'
                        ? 'Compliance Policies'
                        : localStorage.getItem('assignmentType') === 'survey'
                          ? 'User Survey'
                          : 'Audit Log',
                  link: localStorage.getItem('assignmentType') === 'datacollection'
                    ? "/manage/devices/datacollection" : "/manage/devices/remediation"
                },
                { name: contextValue.automationDetails.automationName, link: "#" },
                { name: "Audit Log", link: "#" }
              ]} />
            </StackItem>
          </Stack>
        </StackItem>
      </Stack>
    </StackItem>
  );

  const overflowData = () => {
    const handleRefresh = () => {
      setCurrentPageNo(1);
      setRefresh(true);
      setLoading(true);
    };
    const handleExport = () => { final_data.filter(val => val.pageName === "Remediation assignment" || val.pageName !== "Devices") };

    const refreshButton = () => (
      <StackItem>
        <Button disabled={loading} shape="circular" appearance="subtle" size="small" onClick={handleRefresh}>
          {refreshIcons(<ArrowClockwise20Regular {...(loading ? secondaryIcon : primaryIcon)} />)}
        </Button>
      </StackItem>
    );

    const exportButton = () => (
      <StackItem>
        {permitSecondary
          ? (
            <>
              <CSVLink id="csv-export-link" data={exportData} filename={`${contextValue.automationDetails.automationName}_activityLog.csv`} />
              <Button disabled={loading || tableData.length === 0} shape="circular" appearance="subtle" size="small" onClick={handleExport}>
                {exportIcons(<ArrowDownload20Regular {...(loading || tableData.length === 0 ? secondaryIcon : primaryIcon)} />)}
              </Button>
            </>
          )
          : (
            <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
              <Button shape="circular" appearance="subtle" size="small" disabled>
                {exportIcons(<ArrowDownload20Regular {...secondaryIcon} />)}
              </Button>
            </Tooltip>
          )
        }
      </StackItem>
    );

    const fullscreenButton = () => (
      <StackItem grow shrink>
        <Stack horizontalAlign="end"> <StackItem grow shrink> <FullScreenButton handle={handle} /> </StackItem> </Stack>
      </StackItem>
    );

    const overFlowComponent = {
      data: (
        <>
          {refreshButton()}
          {exportButton()}
          {fullscreenButton()}
        </>
      )
    };

    return (
      <StackItem>
        <OverflowSetCustomExample overlayOpen={overlayOpen} setOverlayOpen={setOverlayOpen} component={overFlowComponent} />
        <Divider />
      </StackItem>
    )
  };

  const searchbarData = () => (
    <StackItem>
      <SearchBar setCurrentPageNo={setCurrentPageNo} columnSearch={"for Module"} searchVal={searchVal} setSearchVal={setSearchVal} setLoading={setLoading} disabled={loading || tableData.length === 0} />
    </StackItem>
  );

  const filterData = () => {
    const columnData = [
      { key: "date", label: cap("Date") },
      { key: "module", label: cap("Module") },
      { key: "activity", label: cap("Activity") },
      { key: "initiated_by", label: cap("Initiated by") },
      { key: "action", label: cap("Action") }
    ];

    const commonDrop = filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`));

    const disbaleApply = !dropDownValue1 || !dropDownValue2 || filterArray.some(filter => filter.startsWith(`${dropDownValue1}:`));

    const handleApply = () => { handleFilterArray(); setFilterMenuOpen(false); };
    const handleCancel = () => { setFilterMenuOpen(false); setDropDownValue1(''); setDropDownValue2(''); };

    const handleReset = () => { setFilterArray([]); setIsFilter(false); setDropDownValue2(''); setResetDisabled(true); setLoading(true); };

    return (
      <>
        <StackItem>
          <MenuDropdown open={filterMenuOpen} btn=
            {
              <MenuButton disabled={loading || tableData.length === 0} shape="circular" size="small" onClick={() => setFilterMenuOpen(true)}>
                {filterIcons(<Filter20Filled {...(loading || tableData.length === 0 ? secondaryIcon : primaryIcon)} />)}
              </MenuButton>
            } itemVal={
              <>
                {body("Add a Filter")}
                <Divider />
                <MenuList>
                  <Stack tokens={{ childrenGap: 5 }}>
                    {empty}
                    <StackItem> {cap("Filter")} </StackItem>
                    <DropdownComponent optionData={columnData} setDropDownValue={(newValue) => { setDropDownValue1(newValue); setDropDownValue2(''); }} dropDownvalue={dropDownValue1} />
                    <StackItem> <Divider /> </StackItem>
                    <StackItem> {cap("Value")} </StackItem>
                    {
                      (dropDownValue1 === 'Date') && <DatepickerComponent setDropDownValue2={setDropDownValue2} maxDate={true} />
                    }
                    {
                      dropDownValue1 === "Activity" && (commonDrop ? exists : <Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />)
                    }
                    {
                      dropDownValue1 === "Initiated by" && (commonDrop ? exists : <DropdownComponent setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} optionData={createdByOptions} />)
                    }
                    {
                      dropDownValue1 === "Module" && (commonDrop ? exists : <DropdownComponent setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} optionData={moduleOptions} />)
                    }
                    {
                      dropDownValue1 === "Action" && (commonDrop ? exists : <DropdownComponent setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} optionData={actionOptions} />)
                    }
                    {
                      dropDownValue1 === "Status" && (commonDrop ? exists : <DropdownComponent setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} optionData={statusOptions} />)
                    }
                    <StackItem> <Divider /> </StackItem>
                    <Stack tokens={{ childrenGap: 10 }} horizontal>
                      <StackItem>
                        <Button shape="circular" onClick={handleApply} disabled={disbaleApply} appearance="primary"> {cap("Apply")} </Button>
                      </StackItem>
                      <StackItem>
                        <Button shape="circular" onClick={handleCancel}> {cap("Cancel")} </Button>
                      </StackItem>
                    </Stack>
                  </Stack>
                </MenuList>
              </>
            }
          />
        </StackItem>
        <StackItem onClick={handleReset}>
          <Button shape="circular" appearance="subtle" size="small" disabled={isResetDisabled}>
            {resetFilterIcons(<FilterDismiss20Filled />)}
          </Button>
        </StackItem>
      </>
    );
  };

  const overlayContent = () => {
    const overLayData: any = {
      size: "large", isTabs: true, headerTitle: <Stack> <Text size={600} weight="semibold"> Audit Log Details </Text> </Stack>,
      tabItems: {
        Activity: (
          <Theme>
            <StackItem> {body("Date and time of activity (UTC)")} - {cap(checkTime ? new Date(checkTime * 1000).toLocaleString() : '')} </StackItem>
            <StackItem> {body(`Date and time of activity (${userTimeZone}`)} - {cap(checkTime ? convertToLocalTimezone(checkTime, userTimeZone) : '')} </StackItem>
            <StackItem> {body("Module where the activity was performed ")} - {cap(checkPageName)} </StackItem>
            <StackItem> {body("Activity")} - {cap(checkSummary)} </StackItem>
            <StackItem> {body("Initiated By")} - {cap(checkInitiate)} </StackItem>
            <StackItem> {body("Action")} - {cap(checkAction)} </StackItem>
            <StackItem> {body("Status")} - {cap(checkStatus)} </StackItem>
          </Theme>
        )
      },
      Targets: '',
      "Modified Properties": '',
      footerData: <FileDownloadComponent data={activityExportData} fileName="Activity_log" />
    };

    const { tabItems: tabs } = overLayData;

    if (Pages("Overview")) {
      tabs.Targets = nope;
      tabs['Modified Properties'] = nope;
    } else if (Pages("Device Classification")) {
      if (ActionA('Add')) {
        tabs.Targets = (
          <Theme>
            <StackItem> {body("Classification name")} - {cap(dataName)} </StackItem>
            <StackItem> {body("Operation type")} - {cap(dataType)} </StackItem>
            <StackItem> {body("Total number of devices added")} - {cap(dataCount)} </StackItem>
            <StackItem> {body("List of devices added")} - <Button shape="circular" size="small" onClick={() => { localStorage.setItem('classificationName', dataName); navigate("/manage/devices/device_classification/devices") }}> Click here </Button> </StackItem>
          </Theme>
        );
        tabs['Modified Properties'] = nope;
      } else if (ActionA('Delete')) {
        tabs.Targets = (<Theme> <StackItem> {body("Classification name")} - {cap(dataClass)} </StackItem> </Theme>)
        tabs['Modified Properties'] = nope;
      } else {
        tabs.Targets = nope;
      };
    } else if (Pages("Devices")) {
      if (ActionB('Edit')) {
        tabs.Targets = (
          <Theme>
            <StackItem> {body("Classification name")} - {cap(dataName)} </StackItem>
            {dataType && <StackItem> {body("Operation type")} - {cap(dataType)} </StackItem>}
            <StackItem> {body("Total number of devices modified")} - {cap(dataCount)} </StackItem>
            <StackItem>
              {body("List of devices")} -
              <Button shape="circular" size="small" onClick={() => { localStorage.setItem('classificationName', dataName); contextValue.setSelectedRowDetails({ ...contextValue.selectedRowDetails, name: dataName }); navigate("/manage/devices/device_classification/devices") }}>
                Click here
              </Button>
            </StackItem>
          </Theme>
        );
        tabs['Modified Properties'] = (
          <Theme>
            {loading ? <SkeletonDataTable /> : tableData.length > 0
              ? <DataTable columns={[{ key: "deviceName", label: body("Device Name") }]}
                tableData={JSON.parse(dataActivity).deviceList.split(",").map((val: any, i: any) =>
                  ({ id: i, checkbox: "hide", deviceName: { label: cap(val), icon: "", status: "" } })
                )}
              /> : none
            }
          </Theme>
        );
      } else {
        tabs.Targets = nope;
        tabs['Modified Properties'] = nope;
      };
    } else if (Pages("Remediation list")) {
      if (ActionB('Export')) {
        tabs.Targets = nope;
        tabs['Modified Properties'] = nope;
      };
    } else if (Pages("Remediation assignment")) {
      if (ActionB('Export')) {
        tabs.Targets = nope;
        tabs['Modified Properties'] = nope;
      } else if (ActionB('Add')) {
        tabs.Targets = (
          <Theme>
            <StackItem> {body("Remediation name")} - {cap(dataRemedy)} </StackItem>
            <StackItem> {body("Attached scope")} - {cap(dataAttach)} </StackItem>
            <StackItem> {body("Detached scope")} - {cap(dataDetach)} </StackItem>
          </Theme>
        );
        tabs['Modified Properties'] = nope;
      };
    } else if (Pages("User Survey list")) {
      if (ActionB('Export')) {
        tabs.Targets = nope;
        tabs['Modified Properties'] = nope;
      };
    } else if (Pages("User Survey assignment")) {
      if (ActionB('Export')) {
        tabs.Targets = nope;
        tabs['Modified Properties'] = nope;
      } else if (ActionB('Add')) {
        tabs.Targets = (
          <Theme>
            <StackItem> {body("Survey name")} - {cap(dataSurvey)} </StackItem>
            <StackItem> {body("Attached devices list")} - {cap(dataAttach)} </StackItem>
            <StackItem> {body("Detached devices list")} - {cap(dataDetach)} </StackItem>
          </Theme>
        );
        tabs['Modified Properties'] = nope;
      };
    } else if (Pages("Compliance Policies list")) {
      if (ActionB('Export')) {
        tabs.Targets = nope;
        tabs['Modified Properties'] = nope;
      };
    } else if (Pages("Compliance Policies assignment")) {
      if (ActionB('Export')) {
        tabs.Targets = nope;
        tabs['Modified Properties'] = nope;
      } else if (ActionB('Add')) {
        tabs.Targets = (
          <Theme>
            <StackItem> {body("Compliance Policies name")} - {cap(dataRemedy)} </StackItem>
            <StackItem> {body("Attached scope")} - {cap(dataAttach)} </StackItem>
            <StackItem> {body("Detached scope")} - {cap(dataDetach)} </StackItem>
          </Theme>
        );
        tabs['Modified Properties'] = nope;
      };
    } else if (Pages("Conditional Access list")) {
      if (ActionB('Export')) {
        tabs.Targets = nope;
        tabs['Modified Properties'] = nope;
      };
    } else if (Pages("Conditional Access assignment")) {
      if (ActionB('Export')) {
        tabs.Targets = nope;
        tabs['Modified Properties'] = nope;
      } else if (ActionB('Add')) {
        tabs.Targets = (
          <Theme>
            <StackItem> {body("Conditional Access name")} - {cap(dataRemedy)} </StackItem>
            <StackItem> {body("Attached scope")} - {cap(dataAttach)} </StackItem>
            <StackItem> {body("Detached scope")} - {cap(dataDetach)} </StackItem>
          </Theme>
        );
        tabs['Modified Properties'] = nope;
      };
    } else if (Pages("Data Collection assignment")) {
      if (ActionB('Export')) {
        tabs.Targets = nope;
        tabs['Modified Properties'] = nope;
      } else if (ActionB('Add')) {
        tabs.Targets = (
          <Theme>
            <StackItem> {body("Data Collection name")} - {cap(dataRemedy)} </StackItem>
            <StackItem> {body("Attached scope")} - {cap(dataAttach)} </StackItem>
            <StackItem> {body("Detached scope")} - {cap(dataDetach)} </StackItem>
          </Theme>
        );
        tabs['Modified Properties'] = nope;
      };
    } else if (Pages("Monitor list")) {
      if (ActionB('Export')) {
        tabs.Targets = nope;
        tabs['Modified Properties'] = nope;
      };
    } else if (Pages("Monitor assignment")) {
      if (ActionB('Export')) {
        tabs.Targets = nope;
        tabs['Modified Properties'] = nope;
      } else if (ActionB('Add')) {
        tabs.Targets = (
          <Theme>
            <StackItem> {body("Remediation name")} - {cap(dataRemedy)} </StackItem>
            <StackItem> {body("Attached scope")} - {cap(dataAttach)} </StackItem>
            <StackItem> {body("Detached scope")} - {cap(dataDetach)} </StackItem>
          </Theme>
        );
        tabs['Modified Properties'] = nope;
      };
    };

    return <OverLay overlayopen={overlayOpen} setOverlayOpen={setOverlayOpen} overlayData={overLayData} />
  };

  const activityTableData = () => {
    const columnPrimary = [
      { key: "date", label: body("Date (UTC)") },
      {
        key: "date_timezoned",
        label: (
          <Stack enableScopedSelectors horizontal tokens={{ childrenGap: 5 }} horizontalAlign="center">
            <StackItem> {body("Date")} </StackItem>
            <StackItem align="center">
              <Tooltip withArrow content={`Timezone : ${formattedTimeZone}`} relationship="description" positioning="above">
                <Info16Filled {...timezoneInfo} style={{ display: "flex" }} />
              </Tooltip>
            </StackItem>
          </Stack>
        )
      },
      { key: "page", label: body("Module") },
      { key: "activity", label: body("Activity") },
      { key: "initiated_by", label: body("Initiated by") },
      { key: "action", label: body("Action") },
      { key: "status", label: body("Status") }
    ];
    return loading ? <SkeletonDataTable /> : tableData.length > 0 ? <DataTable tableData={tableData} columns={columnPrimary} /> : none;
  };

  const countTableData = final_data ? (final_data.filter(val => val.pageName === "Remediation assignment" && val.pageName !== "Devices").length) : 0;
  const pageCount = Math.max(1, Math.ceil(countTableData / 50));

  const filteredContent = () => (
    <Stack horizontal horizontalAlign="space-between" tokens={{ padding: '10px 0px 0px 0px' }}>
      <StackItem>
        {filterArray.length > 0 &&
          <Stack wrap horizontal>
            {filterArray.length > 0 && filterArray.map((item, index) => (
              <Button shape="circular" size="small">
                <Stack tokens={{ childrenGap: 5 }} horizontal>
                  <StackItem> {item.includes("00:00") ? item.split("00:00")[0].trim() : item} </StackItem>
                  <StackItem>
                    <Stack tokens={{ childrenGap: 1 }}>
                      {empty}
                      <StackItem> <Dismiss16Regular onClick={() => { handleCloseFilter(index) }} /> </StackItem>
                    </Stack>
                  </StackItem>
                </Stack>
              </Button>
            ))}
          </Stack>}
      </StackItem>
      <StackItem disableShrink>
        {(tableData.length > 0 && !loading) && (countTableData > 0 &&
          cap(`Showing ${((currentPageNo - 1) * 50) + 1} to ${(currentPageNo * 50) > countTableData ? countTableData : (currentPageNo * 50)} of ${countTableData} Records`)
        )}
      </StackItem>
    </Stack>
  );

  return (
    <FullScreen handle={handle} className="fullScreenBackgroundColor">
      {breadcrumbData()}
      <Stack tokens={{ childrenGap: 20 }} horizontal style={SubSectionResponsive}>
        <StackItem style={DynamicBoxingCSS}>
          <Stack style={DynamicBoxingCSS}>
            <FluentProvider theme={dashboardTheme} style={parentHome}>
              <Stack horizontal style={parentHome}>
                <SideMenu leftOpenSubMenu={leftOpenSubMenu} setleftOpenSubMenu={setleftOpenSubMenu} menuItems={AuditPages("Audit Log")} />
                <StackItem style={DynamicBoxingCSS}>
                  <Stack tokens={{ childrenGap: 10 }} style={parentHome}>
                    {overflowData()}
                    <StackItem style={wraperStyle}>
                      <StackItem>
                        <Stack horizontalAlign="space-between" wrap horizontal tokens={{ childrenGap: 10 }}>
                          <Stack horizontal tokens={{ childrenGap: 10 }}>
                            {searchbarData()}
                            {filterData()}
                          </Stack>
                          {(tableData.length > 0 && !loading) && <StackItem> <Pagination setLoading={setLoading} totalPages={pageCount} currentPageNo={currentPageNo} setCurrentPageNo={countTableData} /> </StackItem>}
                        </Stack>
                        {filteredContent()}
                      </StackItem>
                      <InfoBar showSpaces={true} title={"Attached and Detached Logs performed in the Devices module."} />
                    </StackItem>
                    <Activity_log_func type="getLog" moduleName="Devices" data={final_data} func={set_final_data} searchVal={searchVal} pageNo={(currentPageNo - 1) * 50} setTotalPages={setTotalPages} setTotalRecords={setTotalRecords} isFilter={isfilter} dropDownValue1={dropDownValue1} setIsFilter={setIsFilter} dropDownValue2={dropDownValue2} setExportDetails={setExportDetails} setRefresh={setRefresh} isRefresh={isRefresh} setRefreshToast={setRefreshToast} exportBtnClicked={exportBtnClicked} setExportBtnClicked={setExportBtnClicked} filterArray={filterArray} />
                    {activityTableData()}
                    {refreshToast && <ToastComponent setmessagebar={setIsToast} isToastEnabled={refreshToast} toastIntent="success" position="top-end" title="Success" message={'Data Table Refreshed'} footer="" />}
                  </Stack>
                </StackItem>
              </Stack>
            </FluentProvider>
          </Stack>
          {overlayContent()}
        </StackItem>
        {empty}
      </Stack>
    </FullScreen>
  );
};
